import { getURLSearchParams } from "../../api/utils/network-config"

export const serialiseSearchCriteria = searchCriteria =>
    getURLSearchParams(searchCriteria).toString()

export function idify(data) {
    if (!data) {
        return []
    }
    if (Array.isArray(data)) {
        return data.map(item => item.id || item)
    }
    return data.id || data
}

export function combineData(previousData, newData, offset, isInvalidating) {
    if (isInvalidating || !previousData) {
        return newData
    }
    if (offset >= previousData.length) {
        return previousData.concat(newData)
    } else {
        return [...previousData].splice(offset, newData.length, ...newData)
    }
}
